interface FilterBarProps {
  search: string;
  onSearchChange: (v: string) => void;
  carreiraFilter: string;
  onCarreiraChange: (v: string) => void;
  sexoFilter: string;
  onSexoChange: (v: string) => void;
  avaliacaoFilter: string;
  onAvaliacaoChange: (v: string) => void;
  carreiras: string[];
}

export default function FilterBar({
  search,
  onSearchChange,
  carreiraFilter,
  onCarreiraChange,
  sexoFilter,
  onSexoChange,
  avaliacaoFilter,
  onAvaliacaoChange,
  carreiras,
}: FilterBarProps) {
  const hasFilters = search || carreiraFilter || sexoFilter || avaliacaoFilter;

  return (
    <div className="bg-white rounded-xl border border-zinc-100 p-4 mb-5 space-y-3">
      {/* Linha 1: pesquisa */}
      <div className="relative">
        <div className="w-8 h-8 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none">
          <i className="ri-search-line text-sm" />
        </div>
        <input
          type="text"
          placeholder="Pesquisar por nome ou nº de funcionário..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-9 pr-4 py-2.5 text-[13px] border border-zinc-200 rounded-lg bg-white text-zinc-700 placeholder-zinc-400 focus:outline-none focus:ring-1 focus:ring-zinc-300"
        />
      </div>

      {/* Linha 2: filtros */}
      <div className="flex flex-wrap gap-2 items-center">
        <span className="text-[11px] font-semibold text-zinc-400 uppercase tracking-widest flex-shrink-0">Filtrar:</span>

        <select
          value={carreiraFilter}
          onChange={(e) => onCarreiraChange(e.target.value)}
          className={`text-[13px] border rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-1 focus:ring-zinc-300 cursor-pointer ${carreiraFilter ? 'border-zinc-800 text-zinc-800 font-medium' : 'border-zinc-200 text-zinc-600'}`}
        >
          <option value="">Todas as Carreiras</option>
          {carreiras.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <select
          value={sexoFilter}
          onChange={(e) => onSexoChange(e.target.value)}
          className={`text-[13px] border rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-1 focus:ring-zinc-300 cursor-pointer ${sexoFilter ? 'border-zinc-800 text-zinc-800 font-medium' : 'border-zinc-200 text-zinc-600'}`}
        >
          <option value="">Todos os Géneros</option>
          <option value="M">Masculino</option>
          <option value="F">Feminino</option>
        </select>

        <select
          value={avaliacaoFilter}
          onChange={(e) => onAvaliacaoChange(e.target.value)}
          className={`text-[13px] border rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-1 focus:ring-zinc-300 cursor-pointer ${avaliacaoFilter ? 'border-zinc-800 text-zinc-800 font-medium' : 'border-zinc-200 text-zinc-600'}`}
        >
          <option value="">Todas as Avaliações</option>
          <option value="Excelente">Excelente</option>
          <option value="Muito Bom">Muito Bom</option>
          <option value="Adequado">Adequado</option>
          <option value="Inadequado">Inadequado</option>
        </select>

        {/* Filtros ativos */}
        {hasFilters && (
          <div className="flex items-center gap-1.5 ml-auto flex-wrap">
            {carreiraFilter && (
              <span className="inline-flex items-center gap-1 text-[11px] bg-zinc-900 text-white px-2 py-0.5 rounded-full">
                {carreiraFilter}
                <button onClick={() => onCarreiraChange('')} className="cursor-pointer hover:opacity-70 ml-0.5">
                  <i className="ri-close-line text-[10px]" />
                </button>
              </span>
            )}
            {sexoFilter && (
              <span className="inline-flex items-center gap-1 text-[11px] bg-zinc-100 text-zinc-600 px-2 py-0.5 rounded-full">
                {sexoFilter === 'M' ? 'Masculino' : 'Feminino'}
                <button onClick={() => onSexoChange('')} className="cursor-pointer hover:opacity-70 ml-0.5">
                  <i className="ri-close-line text-[10px]" />
                </button>
              </span>
            )}
            {avaliacaoFilter && (
              <span className="inline-flex items-center gap-1 text-[11px] bg-zinc-100 text-zinc-600 px-2 py-0.5 rounded-full">
                {avaliacaoFilter}
                <button onClick={() => onAvaliacaoChange('')} className="cursor-pointer hover:opacity-70 ml-0.5">
                  <i className="ri-close-line text-[10px]" />
                </button>
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
